import { Injectable, inject } from '@angular/core';
import {
  CheckInWidget,
  CityCodeResult
} from '@com-delta-idp/mnx-capability-check-in-ui';
import { CheckInStaticAem } from '@com-delta-idp/mnx-sitewide-shared-core-smart';
import { AirportDropDown } from '@com-delta-idp/mnx-sitewide-shared-core-ui';
import { CheckInAirportAdapterService } from './check-in-airport-adapter.service';
import { CheckInContentAdapterService } from './check-in-content-adapter.service';

@Injectable({
  providedIn: 'root'
})
export class CheckInAdapterService {
  private contentAdapter = inject(CheckInContentAdapterService);
  private airportAdapter = inject(CheckInAirportAdapterService);

  checkInAemContent!: CheckInStaticAem;

  getContent(
    content: CheckInStaticAem,
    nameLengthConfig?: boolean
  ): CheckInWidget {
    this.checkInAemContent = content;
    return this.contentAdapter.getContent(content, nameLengthConfig);
  }

  initializeAirportModalContent(
    airportList?: CityCodeResult[]
  ): AirportDropDown {
    return this.airportAdapter.initializeAirportModalContent(
      this.checkInAemContent,
      airportList
    );
  }
}
